import { useEffect, useRef, useState, useCallback } from 'react';

export const useLocalStorage = <T>(itemKey: string, defaultValue?: T) => {
  const key = Office.context.partitionKey ? Office.context.partitionKey + itemKey : itemKey;

  const [value, setValue] = useState<T>(() => {
    const currentValue = window.localStorage.getItem(key);
    if (currentValue) return JSON.parse(currentValue) as T;
    return defaultValue;
  });

  const previousKeyRef = useRef<string>('');

  useEffect(() => {
    const previousKey = previousKeyRef.current;

    if (previousKey !== key && previousKey) {
      window.localStorage.removeItem(previousKey);
    }
    previousKeyRef.current = key;

    if (value === undefined) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, JSON.stringify(value));
    }
  }, [value, key, defaultValue]);

  const clearValue = useCallback(() => {
    setValue(undefined);
  }, []);

  return [value, setValue, clearValue] as const;
};
